import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid, Button } from '@material-ui/core';
import styles from "../setting.module.css";
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import Alert from '../../../components/UI/alert'
import ModalCloseButton from '../../../components/UI/ModalCloseButton';
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import { useDispatch } from "react-redux";
import { setChangeEmail } from "store/actions/authActions";

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: '#23AFC4',
        color: 'white',
        width: '17.3rem',
        marginTop: '2.75rem',
        marginBottom: '1.12rem',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#23AFC4',
            color: 'white',
        },
    },
}));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    height: 380,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    p: 4
};

let ChangePasswordSchema = Yup.object().shape({
    newEmail: Yup.string().email('Email must be a valid email').required('New email doesn’t exist!'),
    confirmEmail: Yup.string().email('Email must be a valid email')
        .oneOf([Yup.ref('newEmail'), null], 'Email addresses don’t match.')
        .required('Confirm email doesn’t exist!'),

});

export default function AccountModal(props) {
    const { setOpen, open, setOpenAuthentication, setSuccessEmail, verificationID, setOpenAuthenticationBefore } = props
    const axios = useAxiosPrivate()
    const dispatch = useDispatch()
    const classes = useStyles();
    const initialValues = {
        newEmail: '',
        confirmEmail: ''
    }
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "success",
        message: "",
    });
    useEffect(() => {
        setOpenAuthentication(false)
        // eslint-disable-next-line
    }, [open]);

    const submit = async (e) => {
        try {
            const { data } = await axios.post('/user/change_email_request', {
                verification_id: verificationID,
                email: e.confirmEmail
            });
            if (data?.message === "Pending admin approval!") {
                setSuccessEmail(true)
            } else {
                dispatch(setChangeEmail(e.confirmEmail))
                setOpenAuthenticationBefore(true)
            }
        } catch (error) {
            if (error.response && error.response?.data) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: error.response?.data?.message,
                });
                setTimeout(() => {
                    setAlert({
                        showAlert: false,
                        severity: 'error',
                        message: error.response?.data?.message,
                    });
                }, 5000);
            } else {
                setAlert({
                    showAlert: true,
                    severity: 'error',
                    message: 'Something was wrong!',
                });
                setTimeout(() => {
                    setAlert({
                        showAlert: false,
                        severity: 'error',
                        message: 'Something was wrong!',
                    });
                }, 5000);
            }
        }

    };

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container style={{ marginTop: "2rem" }}>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "-3rem" }}>
                            <ModalCloseButton style={{ position: "static" }} onClick={() => setOpen(false)} />
                        </Grid>
                        <Grid item md={12}>
                            <Formik
                                initialValues={initialValues}
                                onSubmit={submit}
                                validationSchema={ChangePasswordSchema}
                            >
                                {({ dirty, isValid }) => {
                                    return (
                                        <Form>
                                            <Grid container spacing={2} alignItems="center" justifyContent="center" style={{ marginTop: "0.5rem" }}>
                                                <Grid item md={10}>
                                                    <p className={styles.emailText}>
                                                        New Email Address
                                                    </p>
                                                    <Field
                                                        name='newEmail'
                                                        label='Enter'
                                                        component={TextField}
                                                        variant='outlined'
                                                        fullWidth
                                                        margin='dense'
                                                        type={'text'}
                                                        style={{
                                                            fontFamily: 'Poppins',
                                                        }}
                                                    ></Field>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} alignItems="center" justifyContent="center">
                                                <Grid item md={10} style={{ marginTop: "1rem" }}>
                                                    <Field
                                                        style={{ fontFamily: 'Poppins' }}
                                                        name='confirmEmail'
                                                        label='Re-Enter'
                                                        component={TextField}
                                                        variant='outlined'
                                                        fullWidth
                                                        margin='dense'
                                                        type={'text'}
                                                    ></Field>
                                                </Grid>
                                            </Grid>
                                            <Grid container justifyContent="center">
                                                <Grid item md={10} style={{ marginTop: "-1rem", display: "flex", justifyContent: "flex-end" }}>
                                                    <Button
                                                        fullWidth
                                                        size='large'
                                                        type='submit'
                                                        className={classes.button}
                                                        disabled={!dirty || !isValid}
                                                        style={isValid && isValid ? {
                                                            fontSize: '0.9rem',
                                                            lineHeight: '1.25rem',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 300,
                                                            fontStyle: 'normal',
                                                            width: 155,
                                                            height: 38,
                                                            backgroundColor: "#0F9BB0",
                                                            color: "white",
                                                            textTransform: "none"
                                                        } : {
                                                            fontSize: '0.9rem',
                                                            lineHeight: '1.25rem',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 300,
                                                            fontStyle: 'normal',
                                                            width: 155,
                                                            height: 38,
                                                            backgroundColor: "#77D0D1",
                                                            color: "white",
                                                            textTransform: "none"
                                                        }}
                                                    >
                                                        Send Request
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    );
                                }}
                            </Formik>
                        </Grid>
                    </Grid>
                    <Alert showAlert={alert.showAlert} severity={alert.severity} message={alert.message} setAlert={setAlert} />
                </Box>
            </Modal>
        </div>
    );
}